import { TierModel } from '@/shared/src/models/Tier';
import { ApiService } from '@/shared/src/services';
import { ITierService } from '@shared/interfaces/services';

export class TierService extends ApiService implements ITierService {
    constructor() {
        super('tier/parent/');
    }

    getTier(): Promise<TierModel> {
        return this.get('get');
    }
}
